"use client";

import styled from "styled-components";

interface BoxCalcHeightProps {
  $height: string;
}

export const Box = styled.div<BoxCalcHeightProps>`
  width: 100%;
  height: ${({ $height }) => `calc(${$height})`};
`;
